module.exports = __webpack_public_path__ + "img/title3.b183c66e.png";